import React, { Component } from 'react'
import { Experiment, Variation } from '@deal/experiment-js'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import styles from './styles.css'
import { ChatLeadComponent, CategoryType, MessageRichCardType } from '#src/generated/graphql'

export default class ProductCuration extends Component<MessageComponentProps, {}> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      (message.parts[0].body.type === 'new-lead-rich-seq-dealbot-expectation' ||
        message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_HOW_CURATED_WORKS) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.leadId
    )
  }

  public render() {
    const { leadId } = this.props.message.parts[0].body.queryVariables
    return (
      <ChatLeadComponent variables={{ leadId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.lead) {
            const category = data.lead.category
            const categoryName = category ? category.singularDisplayName.toLowerCase() : null

            return (
              <MessageBubble message={this.props.message} className={styles.message}>
                <div>
                  <div className={styles.listTitle}>
                    Here's a quick reminder of how Curated works:
                  </div>
                  <Experiment id="intro-message-copy" default="v1">
                    <Variation id="v1">
                      {category && category.type === CategoryType.SERVICE ? (
                        <>
                          <ul className={styles.list}>
                            <li>
                              We'll connect you directly to a vetted {categoryName} expert. They
                              will join this conversation.
                            </li>
                            <li>
                              Your dedicated expert will help you plan the perfect {categoryName}{' '}
                              experience. They will work with you to find alternatives until the
                              experience meets your exact requirements in pricing and style.
                            </li>
                            <li>
                              When you're 100% happy with your itinerary, you'll be able to book
                              directly on our site.
                            </li>
                          </ul>
                          <div className={styles.recap}>
                            If you want to add any additional details about what you're looking for,
                            feel free to send a message below.
                          </div>
                        </>
                      ) : (
                        <>
                          <ul className={styles.list}>
                            <li>
                              We'll connect you directly to a vetted {categoryName} expert. They
                              will join this conversation.
                            </li>
                            <li>
                              Your dedicated expert will send over a list of options based on your
                              details, pulling from various brands and deals to match your product
                              preferences.
                            </li>
                            <li>
                              They will work with you to find alternatives until the products meet
                              your exact requirements in pricing and style.
                            </li>
                            <li>
                              When you're 100% happy with your recommendations, you'll be able to
                              buy directly on our site.
                            </li>
                          </ul>
                          <div className={styles.recap}>
                            If you want to add any additional details about what you're looking for,
                            feel free to send a message below.
                          </div>
                        </>
                      )}
                    </Variation>
                    <Variation id="v2">
                      {category && category.type === CategoryType.SERVICE ? (
                        <>
                          <ul className={styles.list}>
                            <li>
                              We'll directly connect you to a vetted {categoryName} expert. They
                              will join this conversation.
                            </li>
                            <li>
                              Your dedicated expert will help you plan the perfect {categoryName}{' '}
                              experience based on your preferences.
                            </li>
                            <li>
                              They will personally work with you via email, text, or messaging to
                              create an itinerary that meets your exact preferences.This may take a
                              moment as our experts are real people, not automated messaging.
                            </li>
                            <li>
                              When you're 100% happy with your itinerary, you'll be able to book
                              directly on our site.
                            </li>
                          </ul>
                          <div className={styles.recap}>
                            If you want to add any additional details about what you're looking for,
                            feel free to send a message below.
                          </div>
                        </>
                      ) : (
                        <>
                          <ul className={styles.list}>
                            <li>
                              We'll directly connect you to a vetted {categoryName} expert. They
                              will join this conversation.
                            </li>
                            <li>
                              Your dedicated expert will send over a customized list of products
                              based on your details. This may take a moment as our experts are real
                              people, not automated messaging.
                            </li>
                            <li>
                              They will personally work with you via email, text, or messaging to
                              find the products that meet your exact preferences.
                            </li>
                            <li>
                              When you're 100% happy with your recommendations, you'll be able to
                              buy directly from our site.
                            </li>
                          </ul>
                          <div className={styles.recap}>
                            If you want to add any additional details about what you're looking for,
                            feel free to send a message below.
                          </div>
                        </>
                      )}
                    </Variation>
                  </Experiment>
                </div>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading message!
              </MessageBubbleText>
            )
          }
        }}
      </ChatLeadComponent>
    )
  }
}
